import React from 'react';
import { usePermission } from '../hooks/usePermission';
import { LocalStore } from '../storage/authStore';

export const RoleGuard = ({ 
  role, 
  fallback = null, 
  children 
}) => {
  const loggedUser = LocalStore.getLoggedUserDetails();  

  // Normalize role to an array if it's a string
  const allowedRoles = Array.isArray(role) ? role : [role];

  if (allowedRoles.includes(loggedUser?.role?.title)) {
    return children;
  }

  return fallback;
};